import type { RacemapEvent } from '@racemap/utilities/types/events';
import type { User_Legacy } from '@racemap/utilities/types/users';
import type { Immutable } from 'immer';

export const validateUserIsAuthorized = (
  user: Immutable<User_Legacy> | undefined | null,
  event: RacemapEvent | undefined | null,
) => {
  if (user == null) return false;
  if (user.admin) return true;
  if (event == null) return false;
  return event.creatorId === user.id || event.editorIds.includes(user.id);
};
